import { AssetStatus } from '@/enum/AssetStatus'
import type { OwnershipType } from '@/enum/OwnershipType'
import type { IDimensionSpecifications, IDocument } from '@/interfaces'
import type { IAppUser } from '@/interfaces/app-user/IAppUser'
import type { IEquipmentForm } from '@/interfaces/equipments/IEquipmentForm'
import type { IEquipmentWheelsAndTiresSpecifications } from '@/interfaces/IEquipmentWheelsAndTiresSpecifications'
import AppUser from '../AppUser'
import DimensionSpecifications from '../DimensionSpecifications'
import DocumentModel from '../DocumentModel'
import EquipmentWheelsAndTiresSpecifications from './EquipmentWheelsAndTiresSpecifications'

class EquipmentForm implements IEquipmentForm {
  title: string

  identifier: string

  make: string

  model: string

  year: string

  type: string

  status: AssetStatus

  machineHours: number

  ownership: OwnershipType

  assignedEmployeeId: string

  assignedEmployee: IAppUser

  dimensionSpecifications: IDimensionSpecifications

  wheelsAndTiresSpecifications: IEquipmentWheelsAndTiresSpecifications

  documents: IDocument[]

  constructor(equipmentForm?: any) {
    this.title = equipmentForm?.title
    this.identifier = equipmentForm?.identifier
    this.make = equipmentForm?.make
    this.model = equipmentForm?.model
    this.year = equipmentForm?.year
    this.type = equipmentForm?.type
    this.status = equipmentForm?.status
    this.machineHours = equipmentForm?.machineHours
    this.ownership = equipmentForm?.ownership
    this.assignedEmployeeId = equipmentForm?.assignedEmployeeId
    this.assignedEmployee = new AppUser(equipmentForm?.assignedEmployee)
    this.dimensionSpecifications = new DimensionSpecifications(
      equipmentForm?.dimensionSpecifications
    )

    this.wheelsAndTiresSpecifications = new EquipmentWheelsAndTiresSpecifications(
      equipmentForm?.wheelsAndTiresSpecifications
    )

    this.documents =
      equipmentForm?.documents?.map((document: any) => new DocumentModel(document)) ?? []
  }
}

export default EquipmentForm
